import { Styles } from '@typings/common';

export const failureReason: Styles = {
  whiteSpace: 'pre',
};
